module.exports = __webpack_public_path__ + "img/tiao.c1deeba8.png";